import types from './RequestPriorityType';

/**
 * Короткая метка (P1–P4) — показывается везде, где есть приоритет: цвет только
 * дополняет её и сам по себе смысла не несёт.
 */
export default class RequestPriorityTitle {
    static [types.CRITICAL] = 'P1';
    static [types.HIGH] = 'P2';
    static [types.NORMAL] = 'P3';
    static [types.LOW] = 'P4';
}
